export default {
  '新增场景成功':'新增场景成功',
  '关联设备成功':'关联设备成功',
  '场所编辑成功':'场所编辑成功',
  '设备名，SN号':'设备名，SN号',
  '保存并关闭':'保存并关闭',
  'SN码':'SN码',
  'MAC码':'MAC码',
  '设备列表':'设备列表',
  '设备名、SN码、MAC码':'设备名、SN码、MAC码',
  '添加设备':'添加设备',
  '已选中{num}人':'已选中{num}人',
  '是否确认批量移除{num}个设备？':'是否确认批量移除{num}个设备？',
  '是否确认移除设备{name}？':'是否确认移除设备{name}？',
  '场所列表':'场所列表',
  '场所名':'场所名',
  '关联设备':'关联设备',
  '场所名称':'场所名称',
  '场所类型':'场所类型',
  '场所ID':'场所ID',
  '请输入两位数字ID':'请输入两位数字ID',
  '编辑场所':'编辑场所',
  '新增场所':'新增场所',
  '确认要删除该场所吗？':'确认要删除该场所吗？',
  '场所删除成功！':'场所删除成功！',
}